export default "__VITE_ASSET__CDyW8QVL__"